import React from 'react'
import PropTypes from 'prop-types'
import { StripeProvider, Elements } from 'react-stripe-elements'
import { getStripeKey, getConstant } from 'commons/js/constants'
import PaymentForm from './PaymentForm'

const paymentGatewayId = Number(getConstant('COUNTRY_PAYMENT_GATEWAY_ID'))

const fonts = [
    {
        family: 'geomanist',
        src: 'url("https://s3-us-east-2.amazonaws.com/mowiz-static/fonts/geomanist-regular-webfont.woff#geomanist_regularregular") format("woff")',
        weight: '300',
        style: 'normal',
    },
]

const PaymentFormWrapper = ({ fine, town, onBack, onSuccess, brandId }) => (
    <StripeProvider apiKey={getStripeKey(paymentGatewayId)}>
        <Elements locale='en-US' fonts={fonts}>
            <PaymentForm
              paymentGatewayId={paymentGatewayId}
              fine={fine}
              town={town}
              onBack={onBack}
              brandId={brandId}
              onSuccess={onSuccess}
            />
        </Elements>

    </StripeProvider>
)

PaymentFormWrapper.propTypes = {
    fine: PropTypes.object.isRequired,
    town: PropTypes.object.isRequired,
    onBack: PropTypes.func,
    brandId: PropTypes.number.isRequired,
    onSuccess: PropTypes.func,
}

export default PaymentFormWrapper
